(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["button"] && !Shopify.designMode) return;
  try {
    if (!window.__apeazeAnchorScrollInit) {
    window.__apeazeAnchorScrollInit = true;
    document.addEventListener('click', function (e) {
      var wrapper = e.target.closest('[data-anchor-scroll]');
      if (!wrapper) return;
      var link = wrapper.querySelector('a[href^="#"]');
      if (!link) return;
      var targetId = wrapper.getAttribute('data-anchor-scroll');
      var target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
